@if (!loading && customRegistration) {
  <div class="custom-registration-landing">
    <div class="registration-form-card custom-registration-card">
      <h1 class="custom-registration-title">{{ customRegistration.title }}</h1>
      <div class="custom-registration-intro" [innerHTML]="introHtml"></div>
      @if (infoSnippetHtml) {
        <div class="custom-registration-info" [innerHTML]="infoSnippetHtml">
        </div>
      }
      @if (currentUser) {
        <a class="custom-registration-apply-button" [href]="embeddedFormUrl">
          Apply Now, {{ currentUser.first_name }}
        </a>
      }
      @if (!currentUser && isLoggedInToPlatform) {
        <a class="custom-registration-apply-button" href="/login?return_to={{currentUrl}}" target="_self">
          Log In to Apply Now
        </a>
      }
      @if (!currentUser && !isLoggedInToPlatform) {
        <a class="custom-registration-apply-button" uiSref="signup" [uiParams]="signupParams">
          Sign Up & Apply Now
        </a>
      }
    </div>
  </div>
}

@if (loading) {
  <div class="custom-registration-loading">
    <div class="loading-spinner"></div>
  </div>
}
